import React, { Component } from 'react'
import { Tab, Tabs } from 'react-bootstrap'
import { connect } from 'react-redux';
import Swal from 'sweetalert2';
import { createFeedAction } from '../../../../../../actions/addFeedActions'
import { MediaBaseUrl, HOST_URL } from '../../../../../../actions/api'
import { getInitialRoute, GET_FLITER_ID, isAppleSafari, isPersAcc } from '../../../../../../utils'
import { getFbCode } from '../../../../../../utils/auth'
import NeedHelp from '../Elements/NeedHelp'
import InstaTabs from './instaTabs';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc';


const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

class Instagramfeed extends Component {
    constructor(props) {
        super(props)
        this.state = {
            filterType: 'hashtag',
            errorMsg: 'This field is required',
            hashtag: "",
            handle: '',
            error: false,
            moderation: false,
            hashtagPost: false,
            excludeVideo: false,
            onlyReels: false,
            hanldeError: false,
            account: null,
            connetedAccount: null,
            selectedChildAccount: {},
            personalAcc: {},
            filterId: 26,
            authRequired: 0,
        }
    }



    componentWillMount() {
        this.setState({ authRequired: this.props.feedInfo[0].authRequire })
        this.props.onFilterNameChange(this.state.filterType);
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value, error: false, handleError: false });
    }

    onCheckHandler = event => { this.setState({ [event.target.name]: event.target.checked }) }
    onPersonalAccChange = (value) => this.setState({ personalAcc: value })
    onSelectedChildAccountChange = (value) => this.setState({ selectedChildAccount: value })
    onCheckHandler = event => { this.setState({ [event.target.name]: event.target.checked }) }
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value })

    onAddAccount = () => {
        const { filterId } = this.state;
        localStorage.setItem("networkId", 18)
        localStorage.setItem("connectionType", 'addFeed');
        const perAcc = isPersAcc(filterId);
        Swal.fire({
            imageUrl: `${MediaBaseUrl}square-icons/${perAcc ? 'instagram' : 'facebook'}.svg`,
            maxWidth: "500px",
            customClass: {
                popup: 'facebook-connect-popup',
                confirmButton: 'btn Facebook btn-primary coonect-facebook',
                htmlContainer: 'm-0',
                actions: 'p-0'
            },
            html:
                perAcc ? `<p class="font-weight-boldest text-dark my-3">Connect Instagram toseamlessly pull the content for this feed.
                </p>
                <p class="font-size-sm">NOTE: Socialwalls does not access, store, or view personal information and passwords that you may use to connect your accounts.
                </p>`  : `<p class="font-weight-boldest text-dark my-3">To create ${perAcc ? 'instagram' : 'facebook'} Feed, connect with your Facebook account.</p>
                <p>Watch Video <a href="https://youtu.be/10UKnFsBvXA?t=62" target="_blank">https://youtu.be/10UKnFsBvXA?t=62</a></p>
                <p class="font-size-sm">NOTE: Taggbox does not access, store, or view personal information and passwords that you may use to connect your accounts.
                </p>`,
            showCloseButton: true,
            showCancelButton: false,
            focusConfirm: true,
            confirmButtonColor: filterId == 1 ? '#ff4051' : null,
            confirmButtonText: `Continue with ${perAcc ? 'instagram' : 'facebook'}`,
            confirmButtonAriaLabel: `Continue with ${perAcc ? 'instagram' : 'facebook'}`,
            cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
            cancelButtonAriaLabel: 'Thumbs down'
        }).then((result) => {
            if (result.value) {
                this.props.updateFeedPostBody(this.createFeedPostData());
                if (perAcc) {
                    const url = `https://api.instagram.com/oauth/authorize?client_id=${'584902894093140'}&redirect_uri=${HOST_URL}/feeds/authCallback/&scope=instagram_business_basic,instagram_business_manage_comments&response_type=code`;
                    window.open(url, "_blank", "width=786,height=786");
                }
                else { getFbCode(18); }

            }
            else if (result.dismiss === "cancel") { }
            else if (result.dismiss === "close" || result.dismiss === "backdrop") { this.setState({ loading: false }) }
        });
    }

    createFeedPostData = () => {
        const { onlyReels, filterId, excludeVideo, hashtagPost, hashtag, handle, personalAcc, selectedChildAccount, moderation } = this.state;
        const { wallId, accountId } = this.props;
        const perAcc = isPersAcc(filterId);
        var obj = {
            wallId: wallId,
            networkId: perAcc ? 2 : 18,
            feedText: [24, 88].includes(filterId) ? selectedChildAccount ? selectedChildAccount?.label : "" : perAcc ? personalAcc ? personalAcc?.label : "" : filterId == 26 ? hashtag.split('#').join('') : handle.split('@').join(''),
            hashtagCaption: hashtagPost ? 1 : 0,
            filter: filterId,
            accountId: accountId,
            hashtagIGTV: excludeVideo ? 1 : 0,
            onlyReels: onlyReels ? 1 : 0,
            moderation: moderation ? 1 : 0,
        }

        if ([24, 88].includes(filterId)) obj['accountId'] = selectedChildAccount ? selectedChildAccount?.value : "";
        else if (perAcc) obj['accountId'] = personalAcc ? personalAcc?.value : "";
        return obj;
    }


    createFeed = (connectedAccId, accName) => {
        const { navigation, hideAddfeed, wallId, personalAccount, connectedAcc } = this.props;
        let obj = this.createFeedPostData();
        if (connectedAccId != null) {
            obj = { ...obj, accountId: connectedAccId, feedText: accName ? accName : obj.feedText }
        }

        this.setState({ loading: true, error: false, handleError: false });
        createFeedAction(obj, obj.networkId, (feedId, responseCode) => this.setState({ loading: false }, () => {
            if (responseCode && (responseCode == 403)) {
                const reconnect = isPersAcc(this.state.filterId) ? personalAccount : connectedAcc;
                localStorage.setItem('reconnectAccount', reconnect?.length > 0 ? 1 : 0);
                this.onAddAccount();
                return;
            }

            if (feedId) {
                navigation(`/moderation/index/${wallId}`);
                hideAddfeed();
            }
        }));
    }

    onSubmit = () => {
        const { hashtag, handle, filterId, authRequired } = this.state;
        const { accountId, connectedAcc } = this.props;

        if ((hashtag.trim().length == 0) && filterId == 26) {
            this.setState({ error: true, loading: false })
        } else if ((handle.trim().length == 0) && filterId == 23) {
            this.setState({ handleError: true, loading: false })
        } else {
            if (authRequired) {
                if (accountId) {
                    this.createFeed(null);
                } else {
                    this.onAddAccount();
                }
            } else {
                if ([23, 26].includes(filterId)) {
                    const isConnectAccRequired = connectedAcc.length > 0 ? accountId ? false : true : false;
                    if (isConnectAccRequired) {
                        this.onAddAccount();
                    } else {
                        this.createFeed(accountId != null ? accountId : 0);
                    }
                } else {
                    if (accountId) {
                        this.createFeed(null);
                    } else {
                        this.onAddAccount();
                    }
                }
            }

        }
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        const { filterId } = this.state;
        if (type == "addFeed") {
            const perAcc = isPersAcc(filterId);
            addUserAccount(perAcc ? 2 : networkId, data, [24, 88].includes(filterId) ? (responseData) => this.props.updateConnectedAccountList(responseData) : (connectAccountId, accName) => this.createFeed(connectAccountId, accName), localStorage.getItem('ownerId'), filterId, localStorage.getItem('reconnectAccount'));
        }
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    needSupportLinks = (filterType) => {
        if (getInitialRoute() === 'widget') {
            switch (filterType) {
                case 'hashtag':
                    return ['https://vimeo.com/715473217', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
                case 'handle':
                    return ['https://vimeo.com/715474001', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
                case 'stories':
                    return ['https://vimeo.com/715477239', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
                case 'mentions':
                    return ['https://vimeo.com/715477999', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
                case 'tagged':
                    return ['https://vimeo.com/715478506', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
                case 'videos':
                    return ['https://vimeo.com/715479795', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
                case 'personal':
                    return ['https://vimeo.com/715480065', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
                default:
                    return ['https://vimeo.com/715473217', 'https://taggbox.com/support/add-instagram-feed-using-taggbox-widget/']
            }
        } else {
            switch (filterType) {
                case 'hashtag':
                    return ['https://vimeo.com/543097262/0c5381319c', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
                case 'handle':
                    return ['https://vimeo.com/539066553', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
                case 'stories':
                    return ['https://vimeo.com/539069429/9005ee2ded', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
                case 'mentions':
                    return ['https://vimeo.com/543097262/0c5381319c', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
                case 'tagged':
                    return ['https://vimeo.com/541610838/418ca85e7d', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
                case 'videos':
                    return ['https://vimeo.com/539066553', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
                case 'personal':
                    return ['https://vimeo.com/540119826/96c364fde1', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
                default:
                    return ['https://vimeo.com/543097262/0c5381319c', 'https://taggbox.com/support/add-instagram-business-account-feeds/']
            }
        }
    }

    render() {
        const { feedInfo, connectedAcc, onBack, personalAccount } = this.props
        const { moderation, handle, accountList, handleError, errorMsg, onlyReels, hashtagPost, excludeVideo, personalAcc, filterId, hashtag, loading, connetedAccount, filterType, error } = this.state
        const isPer = isPersAcc(filterId);
        const hideBtn = (!isPer && connectedAcc?.length > 0) ? false : isPer ? !(personalAccount?.length > 0) : false;
        return (
            <>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-body create_feed_wt">
                            <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                                <Tabs defaultActiveKey="hashtag" id="CreateFeedTab" onSelect={(e) => { this.setState({ filterType: e, filterId: GET_FLITER_ID(e, feedInfo) }, () => this.props.onFilterNameChange(e)) }} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                                    {feedInfo && feedInfo.length && feedInfo[0].networkTab && feedInfo[0].networkTab.length ? feedInfo[0].networkTab.map(filter =>
                                        <Tab eventKey={filter.feedtype} key={filter.filter} className="nav-link className= p-0" title={<span>{filter.feedName}</span>}>
                                            <InstaTabs
                                                tabName={filter.feedtype}
                                                onAddAccount={this.onAddAccount}
                                                connetedAccount={connetedAccount}
                                                onConnectedAccountChange={this.onConnectedAccountChange}
                                                tab={filterType}
                                                hashtag={hashtag}
                                                error={error}
                                                connectedAcc={connectedAcc}
                                                onTextChange={this.onChangeHandler}
                                                errorMsg={errorMsg}
                                                onCheckHandler={this.onCheckHandler}
                                                moderation={moderation}
                                                handle={handle}
                                                handleError={handleError}
                                                personalAccount={personalAcc}
                                                hashtagPost={hashtagPost}
                                                onlyReels={onlyReels}
                                                isPersAcc={isPer}
                                                excludeVideo={excludeVideo}
                                                onPersonalAccChange={this.onPersonalAccChange}
                                                onSelectedChildAccountChange={this.onSelectedChildAccountChange}
                                            />
                                        </Tab>
                                    ) : null}

                                </Tabs>
                                <div className="form-actions w-100">
                                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={this.needSupportLinks(filterType)[0]} supportLink={this.needSupportLinks(filterType)[1]} />
                                        <SubmitFeedRequest onSubmit={this.onSubmit} onBack={onBack} loading={loading} hideBtn={hideBtn} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        accountId: state.addFeedReducer.selectedAccount,
        connectedAcc: state.addFeedReducer.connectedAcc,
        accountStatus: state.addFeedReducer.accountStatus,
        personalAccount: state.addFeedReducer.personalAccount,
    }
}

export default connect(mapStateToProps)(Instagramfeed)
